export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const phonePattern = /^\+33[0-9]*$/;
export const numberPattern = /^[0-9]*$/;
export const passwordPattern = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*?[#?!@$%^&*=)(§-])[A-Za-z\d#?!@$%^&*=)(§-]{8,}$/;
export const urlPattern = /^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;